import "../css/frontend.scss";

import DisplayBlock from "./modules/frontend/DisplayBlock";

// eslint-disable-next-line no-unused-vars
const displayBlock = new DisplayBlock();
